import { wrap as withStyle } from 'utils/styles'

const iconPosition = ({ topRight, centerLeft }) => {
  if (topRight) {
    return `
    position: relative;  
    top: -4px;
    left: 1.5px;
  `
  }
  if (centerLeft) {
    return `
    transform: translate(4px, 2.5px);
  `
  }
  return ''
}

const parentPosition = ({ topRight }) => {
  if (topRight) {
    return `
    position: relative;
    left: 2px;
  `
  }
  return ''
}
// the antd tooltip is positioned according to the original position of the child element
// and it is calculated on render (I think). This makes styling/positioning the small icon
// somewhat problematic. This is my "for now" solution, I welcome any and all ideas for
// something cleaner.
const getPositions = (props) => ({
  iconPos: iconPosition(props),
  parentPos: parentPosition(props),
})

export default withStyle((props) => {
  const { iconPos, parentPos } = getPositions(props)
  return `
    && {
      & .chec-icon {
        vertical-align: top;
        border-radius: initial;
        ${iconPos}
      }
      ${parentPos}
    } 
  }
  `
})
